import apiClient from './client';

/** koreavsa-be 관리자 로그인 → { userId, role, token } */
export async function loginAdmin(email, pwd) {
  const { data } = await apiClient.post('/admin/login', { email, pwd });
  return data;
}
